import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=019d57e0&scoped=true&"
import script from "./activities.vue?vue&type=script&lang=ts&"
export * from "./activities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d57e0",
  null
  
)

export default component.exports